module.exports = __webpack_public_path__ + "64da40a0f58165ff6370979310270a4e.png";